import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { getModelFormats } from 'store/actions/rpc';

const POLL_INTERVAL = 10000;
const POLL_TIMEOUT = 300000;

// Polls a model's formats while any of them are publishing, handing each response to onFormats so
// the caller owns the merged view. The API has no PROCESSING state yet, so the timeout is
// currently the only backstop for a conversion that never completes.
export const useFormatPolling = props => {
  const { rpcGuid, pendingFormats, onFormats } = props;
  const dispatch = useDispatch();
  const [ cookies ] = useCookies([ 'user-auth' ]);
  const token = cookies.archvision_token;
  const [ timedOut, setTimedOut ] = useState([]);
  const startedAt = useRef({});
  const pendingKey = pendingFormats.join();

  useEffect(() => {
    if (!rpcGuid || !pendingFormats.length) return undefined;

    pendingFormats.forEach(format => {
      startedAt.current[format] = startedAt.current[format] ?? Date.now();
    });

    const poll = async () => {
      const formats = await dispatch(getModelFormats({ rpcGuid, token }));

      if (formats) {
        onFormats(formats);
      }

      const expired = pendingFormats.filter(format => Date.now() - startedAt.current[format] >= POLL_TIMEOUT);

      if (expired.length) {
        setTimedOut(previous => [ ...new Set([ ...previous, ...expired ]) ]);
      }
    };

    const interval = setInterval(poll, POLL_INTERVAL);

    return () => clearInterval(interval);
  }, [ rpcGuid, pendingKey ]);

  return { timedOut };
};
